import PropTypes from "prop-types";
import React, { useCallback, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Collapse } from "reactstrap";
// Import Data
import navdata from "../LayoutMenuData";
// i18n
import { withTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { createSelector } from "reselect";
import withRouter from "../../Components/Common/withRouter";

const VerticalLayout = props => {
  const rawData = navdata();
  const navData = Array.isArray(rawData) ? rawData : rawData?.props?.children || [];

  const path = props.router.location.pathname;
  const navigate = useNavigate();

  /*
   Layout settings selector
  */
  const selectLayoutState = state => state.Layout;
  const selectLayoutProperties = createSelector(selectLayoutState, layout => ({
    leftsidbarSizeType: layout.leftsidbarSizeType,
    sidebarVisibilitytype: layout.sidebarVisibilitytype,
    layoutType: layout.layoutType,
  }));

  const { leftsidbarSizeType, sidebarVisibilitytype, layoutType } =
    useSelector(selectLayoutProperties);

  const resizeSidebarMenu = useCallback(() => {
    var windowSize = document.documentElement.clientWidth;
    if (windowSize >= 1025) {
      if (document.documentElement.getAttribute("data-layout") === "vertical") {
        document.documentElement.setAttribute("data-sidebar-size", leftsidbarSizeType);
      }
      if (document.documentElement.getAttribute("data-layout") === "semibox") {
        document.documentElement.setAttribute("data-sidebar-size", leftsidbarSizeType);
      }
      if (
        (sidebarVisibilitytype === "show" ||
          layoutType === "vertical" ||
          layoutType === "twocolumn") &&
        document.querySelector(".hamburger-icon")
      ) {
        var hamburgerIcon = document.querySelector(".hamburger-icon");
        if (hamburgerIcon !== null) {
          hamburgerIcon.classList.remove("open");
        }
      } else {
        var hamburgerIcon = document.querySelector(".hamburger-icon");
        if (hamburgerIcon !== null) {
          hamburgerIcon.classList.add("open");
        }
      }
    } else if (windowSize < 1025 && windowSize > 767) {
      document.body.classList.remove("twocolumn-panel");
      if (document.documentElement.getAttribute("data-layout") === "vertical") {
        document.documentElement.setAttribute("data-sidebar-size", "sm");
      }
      if (document.documentElement.getAttribute("data-layout") === "semibox") {
        document.documentElement.setAttribute("data-sidebar-size", "sm");
      }
      if (document.querySelector(".hamburger-icon")) {
        document.querySelector(".hamburger-icon").classList.add("open");
      }
    } else if (windowSize <= 767) {
      document.body.classList.remove("vertical-sidebar-enable");
      if (document.documentElement.getAttribute("data-layout") !== "horizontal") {
        document.documentElement.setAttribute("data-sidebar-size", "lg");
      }
      if (document.querySelector(".hamburger-icon")) {
        document.querySelector(".hamburger-icon").classList.add("open");
      }
    }
  }, [leftsidbarSizeType, sidebarVisibilitytype, layoutType]);

  useEffect(() => {
    window.addEventListener("resize", resizeSidebarMenu, true);
    return () => {
      window.removeEventListener("resize", resizeSidebarMenu, true);
    };
  }, [resizeSidebarMenu]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    const initMenu = () => {
      const pathName = path;
      const ul = document.getElementById("navbar-nav");
      if (!ul) return;
      const items = ul.getElementsByTagName("a");
      let itemsArray = [...items];
      removeActivation(itemsArray);

      const getParentMenuForPath = currentPath => {
        if (currentPath.startsWith("/dashboard")) {
          return "/dashboard";
        }
        if (currentPath.startsWith("/add-project") || currentPath.startsWith("/project/view")) {
          return "/project";
        }
        if (currentPath.startsWith("/add-developer") || currentPath.startsWith("/developer/view")) {
          return "/developer";
        }
        if (currentPath.startsWith("/master/employee/add-employee")) {
          return "/master/employee";
        }
        if (currentPath.startsWith("/master/user/add-user")) {
          return "/master/user";
        }
        if (currentPath.startsWith("/master/add-bank")) {
          return "/master/banks";
        }
        if (currentPath.startsWith("/master/roles/add-role")) {
          return "/master/roles";
        }
        if (
          currentPath.startsWith("/add-inquirie") ||
          currentPath.startsWith("/edit-inquirie") ||
          currentPath.startsWith("/inquiries/details-inquiry") ||
          currentPath.startsWith("/inquiries/excel-upload")
        ) {
          return "/inquiries";
        }
        return currentPath;
      };

      const targetMenuPath = getParentMenuForPath(pathName);

      let matchingMenuItem = itemsArray.find(x => {
        const itemPath = x.getAttribute("href")?.replace(process.env.PUBLIC_URL, "");
        return itemPath === targetMenuPath;
      });

      if (matchingMenuItem) {
        activateParentDropdown(matchingMenuItem);
      }
    };

    if (props.layoutType === "vertical") {
      initMenu();
    }
  }, [path, props.layoutType]);

  function activateParentDropdown(item) {
    item.classList.add("active");
    let parentCollapseDiv = item.closest(".collapse.menu-dropdown");

    if (parentCollapseDiv) {
      parentCollapseDiv.classList.add("show");
      if (parentCollapseDiv.parentElement.children[0]) {
        parentCollapseDiv.parentElement.children[0].classList.add("active");
        parentCollapseDiv.parentElement.children[0].setAttribute("aria-expanded", "true");
      }

      if (parentCollapseDiv.parentElement.closest(".collapse.menu-dropdown")) {
        parentCollapseDiv.parentElement.closest(".collapse").classList.add("show");

        if (parentCollapseDiv.parentElement.closest(".collapse").previousElementSibling)
          parentCollapseDiv.parentElement
            .closest(".collapse")
            .previousElementSibling.classList.add("active");
      }
      return false;
    }
    return false;
  }

  const removeActivation = items => {
    let actiItems = items.filter(x => x.classList.contains("active"));

    actiItems.forEach(item => {
      item.classList.remove("active");
    });
  };

  return (
    <React.Fragment>
      {(navData || []).map((item, key) => {
        return (
          <React.Fragment key={key}>
            {item["isHeader"] ? (
              <li className="menu-title">
                <span>{props.t(item.label)} </span>
              </li>
            ) : item.subItems ? (
              <li className="nav-item">
                {/* Native Velzon Link Structure with data-bs-toggle="collapse" for Auto Arrow */}
                <Link
                  onClick={e => {
                    if (item.click) {
                      item.click(e);
                    }
                    if (item.link === "/dashboard" && path === "/dashboard") {
                      e.preventDefault();
                      navigate("/dashboard", {
                        state: { activeStep: 1 },
                        replace: true,
                      });
                    }
                  }}
                  className={`nav-link menu-link ${item.stateVariables ? "active" : ""}`}
                  to={item.link ? item.link : "/#"}
                  data-bs-toggle="collapse"
                  aria-expanded={!!item.stateVariables}
                >
                  <i className={item.icon}></i>
                  <span>{props.t(item.label)}</span>
                </Link>

                <Collapse className="menu-dropdown" isOpen={!!item.stateVariables}>
                  <ul className="nav nav-sm flex-column">
                    {item.subItems.map((subItem, i) => (
                      <li key={i} className="nav-item">
                        <Link
                          to={subItem.link}
                          className={`nav-link ${path === subItem.link ? "active" : ""}`}
                        >
                          {props.t(subItem.label)}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </Collapse>
              </li>
            ) : (
              <li className="nav-item">
                <Link
                  className={`nav-link menu-link ${path === item.link ? "active" : ""}`}
                  to={item.link ? item.link : "/#"}
                  onClick={e => {
                    if (item.link === "/dashboard" && path === "/dashboard") {
                      e.preventDefault();

                      navigate("/dashboard", {
                        state: { activeStep: 1 },
                        replace: true,
                      });
                    }
                  }}
                >
                  <i className={item.icon}></i>
                  <span>{props.t(item.label)}</span>
                </Link>
              </li>
            )}
          </React.Fragment>
        );
      })}
    </React.Fragment>
  );
};

VerticalLayout.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default withRouter(withTranslation()(VerticalLayout));
